export function MediaSkeletonCard() {
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-border/50 bg-card shadow-sm">
      <div className="aspect-square animate-pulse bg-muted" />
      <div className="p-3">
        <div className="h-4 w-3/4 animate-pulse rounded bg-muted" />
        <div className="mt-1.5 h-3 w-1/2 animate-pulse rounded bg-muted/60" />
      </div>
    </div>
  );
}
